/**
* this is the dashboard component that holds the 4 graph areas
*
* Created by Tom on 07/06/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { ActionCreator } from '../../actions/'

// component import
import DashboardItem from '../../components/DashboardItem/'

// style import
import './style.scss'


class Dashboard extends Component {

    componentDidMount() {
        const { getTransactionData } = this.props
        getTransactionData()
    }

    render() {

        // p* = portfolio, i* = investment, t* = transaction, n* = news
        const { pLoading, pData, iLoading, iData,
                tLoading, tData, nLoading, nData } = this.props

        return (
            <div className="dashboard">

                {/* portfolio graph display box */}
                <div className="dashboard__display-box">
                    <DashboardItem
                        type="portfolio"
                        isLoading={pLoading}
                        data={pData}
                        headerText="WHAT IS MY PORTFOLIO WORTH?"/>
                </div>

                {/* investment graph display box */}
                <div className="dashboard__display-box">
                    <DashboardItem
                        type="investment"
                        isLoading={iLoading}
                        data={iData}
                        headerText="WHAT AM I INVESTED IN?"/>
                </div>

                {/* transaction graph display box */}
                <div className="dashboard__display-box">
                    <DashboardItem
                        type="transaction"
                        isLoading={tLoading}
                        data={tData}
                        headerText="TRANSACTION AMOUNT"/>
                </div>

                {/* news list display box */}
                <div className="dashboard__display-box">
                    <DashboardItem
                        type="news"
                        isLoading={nLoading}
                        data={nData}
                        headerText="LATEST NEWS"/>
                </div>

            </div>
        )
    }
}

// define the prop types
Dashboard.propTypes = {
    getTransactionData: PropTypes.func.isRequired,
    pLoading: PropTypes.bool,
    pData: PropTypes.array,
    iLoading: PropTypes.bool,
    iData: PropTypes.array,
    tLoading: PropTypes.bool,
    tData: PropTypes.array,
    nLoading: PropTypes.bool,
    nData: PropTypes.array
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        pLoading: state.portfolioState.pLoading,
        pData: state.portfolioState.pData,
        iLoading: state.investmentState.iLoading,
        iData: state.investmentState.iData,
        tLoading: state.transactionState.tLoading,
        tData: state.transactionState.tData,
        nLoading: state.newsState.nLoading,
        nData: state.newsState.nData
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getTransactionData: action.getTransactionData
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js